import { render, staticRenderFns } from "./SceneCustomEdit.vue?vue&type=template&id=2bbdc77f&scoped=true&"
import script from "./SceneCustomEdit.vue?vue&type=script&lang=js&"
export * from "./SceneCustomEdit.vue?vue&type=script&lang=js&"
import style0 from "./SceneCustomEdit.vue?vue&type=style&index=0&id=2bbdc77f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbdc77f",
  null
  
)

export default component.exports